class SpecsheetGeneratorHelper {
  /**
   * Load all required scripts for specsheet PDF generation.
   * If they are already loaded it will just return the existing modules.
   * @returns Promise<Module[]>
   */
  static loadScripts() {
    return Promise.all([
      import(confEnv.www_url + specsheetPdfGeneratorPath),
      import(confEnv.www_url + pdfLibPath),
      import(confEnv.www_url + fontkitPath),
    ]);
  }

  /**
   * Try to generate a specsheet PDF for the given accessory ID.
   * @param {string} accessoryId - formatted Accessory ID
   * @returns Promise<void>
   */
  async generateAccessorySpecsheet(accessoryId) {
    try {
      await SpecsheetGeneratorHelper.loadScripts();

      const accessoryData = await fetch(
        `${confEnv.product_api_url}/accessories/formatted/${accessoryId}?language=${k3vars.S_Sprache}`,
      ).then((response) => {
        if (!response.ok) {
          throw new Error(
            `Failed to fetch accessory data: ${response.status} ${response.statusText}`,
          );
        }
        return response.json();
      });

      if (!globals.trans['specsheets']) {
        await new Promise((resolve) =>
          jsTranslation.getContext('specsheets', resolve),
        );
      }

      const pdfGenerator = new SpecsheetGenerator(accessoryData, {
        lightscoutUrl: confEnv.www_url,
        environment: 'browser',
        translations: globals.trans.specsheets,
      });

      pdfGenerator.saveDocument();
    } catch (error) {
      // TODO: Handle error more gracefully in the UI
      console.error(
        'Error generating accessory specsheet PDF for ID:',
        accessoryId,
        error,
      );
    }
  }
}

const specsheetGeneratorHelper = new SpecsheetGeneratorHelper();
